import { LoadState } from "../../constants/enums";
import { getUniqueId } from "../../helpers";

export interface IAllApplicationState {
  list: IAllApplication[];
  totalRecords: number;
  loading: LoadState;
  application: IAllApplication;
  applicationLoading: LoadState;
  errorApplication: string | null;
  userOffBoard: IUserOffboarding;
  userOffBoardLoading: LoadState;
  userOnBoard: IUserOnboarding;
  userOnBoardLoading: LoadState;
  rquestFormLoading: LoadState;
  requestFormList: IHrRequestFormDialog[];
  error: string | null;
}

export interface IHrRequestFormDialog {
  branch_name: string | null;
  user_fact_id: number | null;
  user_code: string | null;
  user_request_code: string;
  type: string | null;
  role_id: string | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  postal_code: string | null;
  country: string | null;
  details: string | null;
  status: string;
  server: string | null;
  powerbroker: string | null;
  portal: string | null;
  applied_rating_services: string | null;
  insurer_portal_ids: string | null;
  notify_ribo: string | null;
  order_business_card: string | null;
  prior_brokerage: string | null;
}
export interface IJobExperience {
  key: string | null;
  job_title: string | null;
  from: string | null;
  to: string | null;
  employer_name: string | null;
  job_description: string | null;
}
export interface IJobReference {
  key: string | null;
  name: string | null;
  company: string | null;
  position: string | null | null;
  phone: string | null;
}
export interface IAllApplication {
  application_number: string;
  first_name: string | null;
  last_name: string | null;
  date_of_birth: string | null;
  email: string | null;
  mailing_address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  state_or_province: string | null;
  postal_code: string | null;
  country: string | null;
  mobile: string;
  phone: string;
  linkedin_profile: string | null;
  licenses_held: string | null;
  licenses: string[] | null;
  position_applied_for: string | null;
  branch: string | null;
  specify_other_license: string | null;
  disciplinary_action: string | null;
  languages_spoken: string | null;
  languages_written: string | null;
  job_experience: IJobExperience[];
  upload_resume: null;
  upload_cover_letter: null;
  file_name_one: string | null;
  cover_letter_one: null;
  file_name_two: string | null;
  cover_letter_two: null;
  file_name_three: string | null;
  cover_letter_three: null;
  file_name_four: string | null;
  cover_letter_four: null;
  file_name_five: string | null;
  cover_letter_five: null;
  file_name_six: string | null;
  cover_letter_six: null;
  file_name_seven: string | null;
  cover_letter_seven: null;
  file_name_eight: string | null;
  cover_letter_eight: null;
  additional_questions: {
    written_contract: string | null;
    non_solicitation_contract: string | null;
    eligible_to_work_in_canada: string | null;
    insurance_broker: string | null;
    found_guilty_of_a_criminal: string | null;
  };
  reference: IJobReference[];
  comments: string | null;

  commission_table: {
    producer_one_endorsement_percentage: string | null;
    producer_one_new_percentage: string | null;
    producer_one_renewal_percentage: string | null;

    producer_two_endorsement_percentage: string | null;
    producer_two_new_percentage: string | null;
    producer_two_renewal_percentage: string | null;

    producer_three_endorsement_percentage: string | null;
    producer_three_new_percentage: string | null;
    producer_three_renewal_percentage: string | null;

    house_new_percentage: string | null;
    house_renewal_percentage: string | null;
    house_endorsement_percentage: string | null;

    branch_new_percentage: string | null;
    branch_renewal_percentage: string | null;
    branch_endorsement_percentage: string | null;
  };

  status: string;
  follow_up_date: string | null;
  your_status_in_canada: string;
  permit_student_visa_expiry: string;
  sign_name: string;
  sign_attachment: string | null;
  is_confirm: string;
  is_authorize: string;
  is_acknowledge: string;
  user_fact_id: number | null;
  user_creation_status: number | null;
}
export interface IUserOffboarding {
  incremental_number: number | null;
  select_user: string | null;
  branch: string | null;
  date: string;
  assigned_to_id: number | null;
  office_information: {
    server: {
      required: string | null;
      send_email: string | null;
    };
    bms: {
      required: string | null;
      send_email: string | null;
    };
    ribo: {
      required: string | null;
      send_email: string | null;
    };
    power_broker: {
      required: string | null;
      send_email: string | null;
    };
    insurer_credentials: {
      required: string | null;
      send_email: string | null;
    };
    last_day_at_work: {
      required: string | null;
      send_email: string | null;
    };
    payroll: {
      required: string | null;
      send_email: string | null;
    };
    // user_on_aaxel_portal: {
    //   required: string | null;
    //   send_email: string | null;
    // };
    // orientation_document_provided: {
    //   required: string | null;
    //   send_email: string | null;
    // };
    // applied_rating_services: {
    //   required: string | null;
    //   send_email: string | null;
    // };
    // e_signature: {
    //   required: string | null;
    //   send_email: string | null;
    // };
  };
  comments: string | null;
  status: string;
}

export const initialApplication: IAllApplication = {
  application_number: "",
  first_name: null,
  last_name: null,
  date_of_birth: null,
  email: null,
  mailing_address: null,
  unit_or_suite: null,
  city: null,
  state_or_province: null,
  branch: null,
  position_applied_for: null,
  postal_code: null,
  country: null,
  mobile: "",
  phone: "",
  linkedin_profile: null,
  licenses_held: null,
  licenses: [],
  specify_other_license: null,
  disciplinary_action: null,
  languages_spoken: null,
  languages_written: null,
  follow_up_date: null,
  user_creation_status: null,
  job_experience: [
    {
      key: getUniqueId(),
      job_title: null,
      from: null,
      to: null,
      employer_name: null,
      job_description: null,
    },
  ],
  upload_resume: null,
  upload_cover_letter: null,
  file_name_one: null,
  cover_letter_one: null,
  file_name_two: null,
  cover_letter_two: null,
  file_name_three: null,
  cover_letter_three: null,
  file_name_four: null,
  cover_letter_four: null,
  file_name_five: null,
  cover_letter_five: null,
  file_name_six: null,
  cover_letter_six: null,
  file_name_seven: null,
  cover_letter_seven: null,
  file_name_eight: null,
  cover_letter_eight: null,
  additional_questions: {
    written_contract: null,
    non_solicitation_contract: null,
    eligible_to_work_in_canada: null,
    insurance_broker: null,
    found_guilty_of_a_criminal: null,
  },
  reference: [
    {
      key: getUniqueId(),
      name: null,
      company: null,
      position: null,
      phone: null,
    },
  ],
  comments: null,
  status: "Application Recieved",
  your_status_in_canada: "",
  permit_student_visa_expiry: "",
  sign_name: "",
  sign_attachment: null,
  is_acknowledge: "N",
  is_authorize: "N",
  is_confirm: "N",
  user_fact_id: null,
  commission_table: {
    producer_one_endorsement_percentage: null,
    producer_one_new_percentage: null,
    producer_one_renewal_percentage: null,
    producer_two_endorsement_percentage: null,
    producer_two_new_percentage: null,
    producer_two_renewal_percentage: null,
    producer_three_endorsement_percentage: null,
    producer_three_new_percentage: null,
    producer_three_renewal_percentage: null,
    house_new_percentage: null,
    house_renewal_percentage: null,
    house_endorsement_percentage: null,
    branch_new_percentage: null,
    branch_renewal_percentage: null,
    branch_endorsement_percentage: null,
  },
};

export const initialUserOffboarding: IUserOffboarding = {
  incremental_number: null,
  select_user: null,
  branch: null,
  date: "",
  assigned_to_id: null,
  office_information: {
    server: {
      required: "ACTIVE",
      send_email: null,
    },
    bms: {
      required: "ACTIVE",
      send_email: null,
    },
    ribo: {
      required: "Pending",
      send_email: null,
    },
    power_broker: {
      required: "ACTIVE",
      send_email: null,
    },
    insurer_credentials: {
      required: "Pending",
      send_email: null,
    },
    last_day_at_work: {
      required: "Pending",
      send_email: null,
    },
    payroll: {
      required: "Pending",
      send_email: null,
    },
    // user_on_aaxel_portal: {
    //   required: null,
    //   send_email: null,
    // },
    // orientation_document_provided: {
    //   required: null,
    //   send_email: null,
    // },
    // applied_rating_services: {
    //   required: null,
    //   send_email: null,
    // },
    // e_signature: {
    //   required: null,
    //   send_email: null,
    // },
  },
  comments: null,
  status: "ACTIVE",
};

export interface IUserOnboarding {
  application_number: string;
  office_information: {
    thankyou_email: {
      required: string | null;
      send_email: string | null;
    };
    aggrement: {
      required: string | null;
      send_email: string | null;
    };
    ribo: {
      required: string | null;
      send_email: string | null;
    };
    ribo_employment_letter: {
      required: string | null;
      send_email: string | null;
    };
    insurer_credentials: {
      required: string | null;
      send_email: string | null;
    };
    user_set_up_server: {
      required: string | null;
      send_email: string | null;
    };
    power_broker: {
      required: string | null;
      send_email: string | null;
    };
    bms: {
      required: string | null;
      send_email: string | null;
    };
    rating_engine: {
      required: string | null;
      send_email: string | null;
    };
    learing_center_access: {
      required: string | null;
      send_email: string | null;
    };
    payroll_setup: {
      required: string | null;
      send_email: string | null;
    };
    orientation: {
      required: string | null;
      send_email: string | null;
    };
    business_cards: {
      required: string | null;
      send_email: string | null;
    };
    // aris_agreement_signed: {
    //   required: string | null;
    //   send_email: string | null;
    // };
  };
  user_defaults: {
    role_assignment: {
      required: string | null;
      send_email: string | null;
    };
    branch_assignment: {
      required: string | null;
      send_email: string | null;
    };
    phone_number_assignment: {
      required: string | null;
      send_email: string | null;
    };
    email_account_assignment: {
      required: string | null;
      send_email: string | null;
    };
    security_group_assignment: {
      required: string | null;
      send_email: string | null;
    };
  };
  status: string;
}

export const initialUserOnboard: IUserOnboarding = {
  application_number: "",
  office_information: {
    thankyou_email: {
      required: "Pending",
      send_email: null,
    },
    aggrement: {
      required: "Pending",
      send_email: null,
    },
    ribo: {
      required: "Pending",
      send_email: null,
    },
    ribo_employment_letter: {
      required: "Pending",
      send_email: null,
    },
    insurer_credentials: {
      required: "Pending",
      send_email: null,
    },
    user_set_up_server: {
      required: "Pending",
      send_email: null,
    },
    power_broker: {
      required: "Pending",
      send_email: null,
    },
    bms: {
      required: "Pending",
      send_email: null,
    },
    rating_engine: {
      required: "Pending",
      send_email: null,
    },
    learing_center_access: {
      required: "Pending",
      send_email: null,
    },
    payroll_setup: {
      required: "Pending",
      send_email: null,
    },
    orientation: {
      required: "Pending",
      send_email: null,
    },
    business_cards: {
      required: "Pending",
      send_email: null,
    },
    // aris_agreement_signed: {
    //   required: null,
    //   send_email: null,
    // },
  },
  user_defaults: {
    role_assignment: {
      required: null,
      send_email: null,
    },
    branch_assignment: {
      required: null,
      send_email: null,
    },
    phone_number_assignment: {
      required: null,
      send_email: null,
    },
    email_account_assignment: {
      required: null,
      send_email: null,
    },
    security_group_assignment: {
      required: null,
      send_email: null,
    },
  },
  status: "ACTIVE",
};

export const initialAllApplicationState: IAllApplicationState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
  application: initialApplication,
  applicationLoading: LoadState.NotLoaded,
  errorApplication: null,
  userOffBoard: initialUserOffboarding,
  userOffBoardLoading: LoadState.NotLoaded,
  userOnBoard: initialUserOnboard,
  userOnBoardLoading: LoadState.NotLoaded,
  rquestFormLoading: LoadState.NotLoaded,
  requestFormList: [],
  error: null,
};
